export default __webpack_public_path__ + "static/media/3334 spice rack C side.1c1c4742.png";